module.exports = __webpack_public_path__ + "media/images/favicons/favicon-tuesday-548da0b353713aa063bb3d7e0bddf57d.ico";